import React from 'react'
import CreateForm from '../../../forms/create/CreateForm'

const AddForm = () => {
    return (
        <div className="w-full flex flex-col px-10 h-[90vh] overflow-y-scroll no-scrollbar ">
        <div className="branch_header">
          <div className="branch_header_title_group">
            <div className="branch_header_title_main">Create Form</div>
        
          </div>
        </div>
        <CreateForm/>
        {/* <SearchBox /> */}
        {/* <Modal title='Create Branch' form={<CreateBranch/>} toggleModal={toggleModal} handleToggle={handleModalToggle} />
        <PortalDataTable cols={branchColumns} loading={isLoading} rows={data} /> */}
      </div>
    )
}

export default AddForm
